import { createLazyComponent } from '@luna/utils-ui';

export const LazyDevToolsDock = createLazyComponent(() =>
    import('./DevToolsDock' /* webpackChunkName: "DevToolsDock" */).then(
        ({ DevToolsDock }) => DevToolsDock,
    ),
);
